import styled from '@emotion/styled';
import Image from '@base/Image';
import { useDSTMetaInfoStore } from '@stores/dst/dstStore';
import Card from '@cont/Quiz/Details/Description/Stats/Card';
import { emptyObject } from '@constants/empty';
import { Spacings } from '@styles/index';
import { DST_INFO } from '@cont/DST/constants';
import useLanguages from '../Common/useLanguages';

const SheetIcon = 'quiz/sheet.svg';
const LanguageIcon = 'quiz/language.svg';

const Wrapper = styled.div`
  display: grid;
  grid-gap: ${Spacings.SPACING_5B};
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
`;

const Stats = () => {
  const { quizInfo } = useDSTMetaInfoStore();

  const {
    numQuestions = DST_INFO.TOTAL_QUESTIONS,
    totalScore = DST_INFO.TOTAL_SCORE,
    duration = DST_INFO.DURATION
  } = quizInfo ?? emptyObject;

  const { formatedLanguages } = useLanguages();

  const getInfoList = () => {
    const infoList = [];
    infoList.push(
      <Card
        key="quiz-info-card"
        icon={<Image width={25} height={25} src={SheetIcon} alt="quiz info" />}
        info={{
          text: `${numQuestions} Q’s · ${totalScore} marks`,
          subText: `${Math.round(duration / 60)} mins`
        }}
      />
    );

    if (formatedLanguages) {
      infoList.push(
        <Card
          key="quiz-language-card"
          icon={
            <Image width={20} height={20} src={LanguageIcon} alt="languages" />
          }
          info={{ text: 'Languages', subText: formatedLanguages }}
        />
      );
    }
    return infoList;
  };

  return <Wrapper>{getInfoList()}</Wrapper>;
};

export default Stats;
